module.exports = __webpack_public_path__ + "img/heart-crack.94956399.svg";